import { Button, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { DAY, MONTH, YEAR } from '../../../constants';
import LineChart from '../../charts/ticket/LineChart';
import { useEffect, useState } from 'react';
import ViewsAndSalesChartService from '../../../services/MeTicketAdditional/ViewsAndSalesChartService';
import useIsSingleDayPeriod from '../../../hooks/useIsSingleDayPeriod';

const hasNonZeroValues = (datasets) =>
  datasets.some(
    (dataset) =>
      Array.isArray(dataset.data) &&
      dataset.data.some((value) => {
        const numericValue = Number(value);
        return Number.isFinite(numericValue) && numericValue !== 0;
      })
  );

function SalesChart({ data }) {
  const {t} = useTranslation()
  const [activeButton, setActiveButton] = useState(DAY)
  const [formattedGraphicData, setFormattedGraphicData] = useState({
    labels: [],
    datasets: []
  })
  const { isSingleDayPeriod } = useIsSingleDayPeriod();

  useEffect(() => {
      if (data) {
        let chartData
        let type
        let currency
        if (data.singleEventsTicketsStatistic) {
          chartData = data.singleEventsTicketsStatistic
          type = 'income'
          currency = data.currency + ' '
        } else {
          chartData = data.salesAndViewsDiagrams
          type = 'sales'
          currency = data.currency + ' '
        }
        const formattedData = ViewsAndSalesChartService(data, chartData, activeButton, type, t, currency)
        formattedData.datasets = formattedData.datasets.filter((dataset) =>
          hasNonZeroValues([dataset])
        );
        if (!formattedData.datasets.length) {
          formattedData.datasets.push('-1')
          formattedData.labels = [""]
        }
        setFormattedGraphicData(formattedData)
      }
  }, [activeButton, data, t])

  const hasSalesData = hasNonZeroValues(formattedGraphicData.datasets);

  return (
    <Col xs={12} lg={12} className={"border rounded-1"}>
      <Col xs={12} lg={12}
           className={`p-3 ${hasSalesData ? '' : 'opacity-25'}`}>
        <Row className="justify-content-between">
          <Col xs={12} lg={'auto'}>
            <div className="fw-bold fs-4 mb-2 text-capitalize">
              {t('ticketStatistic.salesChart')}
            </div>
          </Col>
          {!isSingleDayPeriod && (
            <Col xs={12} lg={'auto'}>
              <ButtonGroup className="w-100 w-lg-auto">
                <Button
                  active={activeButton === YEAR}
                  variant="outline-lightGray"
                  onClick={() => setActiveButton(YEAR)}
                >
                  {t('ticketStatistic.year')}
                </Button>
                <Button
                  active={activeButton === MONTH}
                  onClick={() => setActiveButton(MONTH)}
                  variant="outline-lightGray"
                >
                  {t('ticketStatistic.month')}
                </Button>
                <Button
                  active={activeButton === DAY}
                  onClick={() => setActiveButton(DAY)}
                  variant="outline-lightGray"
                >
                  {t('ticketStatistic.day')}
                </Button>
              </ButtonGroup>
            </Col>
          )}
        </Row>
        <Row>
          <LineChart
            formattedData={formattedGraphicData}
            additionalClass="col-12"
            valuePrefix={data?.currency ? `${data.currency} ` : ''}
          />
        </Row>
      </Col>

    </Col>
  );
}

export default SalesChart
